<template>
  <div>
    <v-expansion-panel-content :key="id" expand-icon="" class="content-bg--2">
      <template #header v-if="['xs'].includes($vuetify.breakpoint.name)">
        <div class="font-weight-medium pr-0">
          <v-layout
            class="font-weight-bold align-center justify-space-between display-1"
          >
            <span class="text-truncate">{{ item.name }}</span>
            <v-btn @click.native.stop="openDialog" icon class="text-xs-center">
              <icon-dots size="17"></icon-dots>
            </v-btn>
          </v-layout>
          <div>
            <div
              v-if="item.start && item.end && new Date(item.end) < new Date()"
              :class="dateClass"
              class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
            >
              С {{ start }} по {{ end }} (завершена)
            </div>
            <div
              v-else-if="item.start && item.end"
              :class="dateClass"
              class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
            >
              С {{ start }} по {{ end }}
            </div>
            <div
              v-else
              :class="dateClass"
              class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
            ></div>
          </div>
          <div>
            <icon-angle size="10" class="icon-angle mr-1"></icon-angle>
            Статистика
          </div>
        </div>
      </template>

      <v-layout
        column
        justify-space-between
        ma-0
        class="content-bg--2 text-xs-left pb-5 pt-4 px-4 fill-height"
      >
        <v-layout
          class="display-1 font-weight-bold align-center justify-space-between pa-3"
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
        >
          <span class="text-truncate">{{ item.name }}</span>
          <button
            @click="deletePoll"
            class="link align-self-end"
            v-if="!['xs'].includes($vuetify.breakpoint.name)"
          >
            <icon-close></icon-close>
          </button>
        </v-layout>

        <div
          v-if="item.start && item.end && new Date(item.end) < new Date()"
          :class="dateClass"
          class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
        >
          С {{ start }} по {{ end }} (завершена)
        </div>
        <div
          v-else-if="item.start && item.end"
          :class="dateClass"
          class="display-0 pl-1 pb-2 font-weight-medium text--secondary subtitle-2"
        >
          С {{ start }} по {{ end }}
        </div>
        <div
          v-else
          :class="dateClass"
          class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
        ></div>

        <v-flex
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
          xs12
          md12
          class="display-0 font-weight-medium pl-0 pb-1 mb-4 v-flex v-flex--border subtitle-2"
        >
          <span class="text-no-wrap">
            <v-btn
              :to="{ name: 'pollSettings', params: { id: id } }"
              icon
              class="ma-0"
            >
              <icon-pencil></icon-pencil>
            </v-btn>
          </span>
          Изменить
          <span class="text-no-wrap">
            <v-btn @click="copyPoll" icon class="ma-0">
              <icon-copy></icon-copy>
            </v-btn>
          </span>
          Дублировать
        </v-flex>

        <div
          class="adv-item-filters fill-height"
          :class="{ 'd-block': ['xs'].includes($vuetify.breakpoint.name) }"
        >
          <v-flex
            md6
            sm6
            class="subtitle-2 pt-2 pl-0 text--secondary font-weight-medium hotspot"
            :class="{ 'pr-0 pt-0': ['xs'].includes($vuetify.breakpoint.name) }"
          >
            <label>Адрес</label>
            <div
              v-if="hotspots.length === 1"
              class="display-0 pt-1 mt-1 pb-3 font-weight-medium subtitle-2 text--primary text-capitalize text-truncate"
            >
              {{ hotspots[0].address }}
            </div>
            <v-select
              v-if="hotspots.length !== 1"
              @change="getStats()"
              :items="hotspots"
              height="32"
              item-value="id"
              item-text="address"
              v-model="hotspot_id"
              class="pb-3 adv-hotspot"
              append-icon=""
              hide-details
              dense
              solo
            >
              <template #append>
                <icon-angle
                  class="ma-0 link"
                  :color="
                    $store.getters.themeDark
                      ? $vuetify.theme.primary
                      : $vuetify.theme.theme
                  "
                ></icon-angle>
              </template>
              <template v-slot:selection="{ item }">
                <div class="ellipsis text-capitalize">
                  {{ item.address ? item.address : item.title }}
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div class="ellipsis text-capitalize">
                  {{ item.address ? item.address : item.title }}
                </div>
              </template>
            </v-select>
          </v-flex>

          <v-flex
            md6
            class="subtitle-2 pt-2 pl-0 text--secondary font-weight-medium adv-datepicker"
            :class="{ 'pr-0': ['xs'].includes($vuetify.breakpoint.name) }"
          >
            <label> За период </label>
            <date-range-picker
              :range="range"
              :index="index"
              @update="changeDate($event)"
            ></date-range-picker>
          </v-flex>
        </div>

        <v-flex xs12 class="pt-2 pb-4 font-weight-medium text-xs-right">
          <poll-chart :graphData="graphData" v-if="graphLoad"></poll-chart>
        </v-flex>

        <v-flex
          xs12
          class="pt-2 pl-0 font-weight-medium text-xs-right subtitle-2"
        >
          <div class="pb-2 pt-2 square-border">
            Всего ответов: {{ countAnswers }}
          </div>
          <v-flex v-for="answer in graphData" :key="answer.id" class="pa-0">
            <div
              class="pb-2 pt-2 text-xs-left"
              :class="
                !(answer.value === 0 && graphData.length === 1)
                  ? 'square-border'
                  : ''
              "
            >
              <div
                v-if="!(answer.value === 0 && graphData.length === 1)"
                :class="answer.bg_color_class"
                class="square"
              ></div>
              <span>{{ answer.name }}</span>
              <span v-if="answer.value > 0" class="adv-counts">
                {{ ((answer.value / countAnswers) * 100).toFixed(2) }}
                % ({{ answer.value }})
              </span>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-expansion-panel-content>

    <v-dialog v-model="dialogDrawer" content-class="adv-dialog">
      <v-card class="content-bg--2">
        <div class="font-weight-bold display-1 pl-3 pr-2 pt-4">
          {{ item.name }}
        </div>
        <div class="pl-3 py-2">
          <div
            v-if="item.start && item.end && new Date(item.end) < new Date()"
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }} (завершена)
          </div>
          <div
            v-else-if="item.start && item.end"
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          >
            С {{ start }} по {{ end }}
          </div>
          <div
            v-else
            :class="dateClass"
            class="display-0 pb-2 font-weight-medium text--secondary subtitle-2"
          ></div>
        </div>
        <v-divider></v-divider>
        <div class="pl-3 pr-4 pt-3 pb-4">
          <div class="py-1 pl-2">
            <icon-pencil class="mr-4"></icon-pencil>
            <v-btn
              :to="{ name: 'pollSettings', params: { id: id } }"
              icon
              class="ma-0"
            >
              <span class="ml-3">Изменить</span>
            </v-btn>
          </div>
          <div class="pt-1 pl-2">
            <icon-copy class="mr-4"></icon-copy>
            <v-btn @click="copyPoll" icon>
              <span class="ml-4">Дублировать</span>
            </v-btn>
          </div>
          <div class="py-1 pl-2">
            <icon-close class="mr-3"></icon-close>
            <v-btn @click="deletePoll" icon>
              <span>Удалить</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import requestApi from "../../modules/requestApi";
import IconClose from "../icon/IconClose.vue";
import IconPencil from "../icon/IconPencil.vue";
import IconAngle from "../icon/IconAngle.vue";
import IconCopy from "../icon/IconCopy.vue";
import IconDots from "../icon/IconDots";
import DateRangePicker from "../common/DateRangePicker.vue";
import moment from "moment";
import PollChart from "./PollChart.vue";

export default {
  name: "PollItem",

  components: {
    IconAngle,
    IconPencil,
    IconClose,
    IconCopy,
    IconDots,
    DateRangePicker,
    PollChart,
  },
  data: () => ({
    // цвета и классы для графика
    colors: [
      { bg_color_class: "square-yellow", bg_color: "#FFD970" },
      { bg_color_class: "square-green", bg_color: "#92CC6D" },
      { bg_color_class: "square-light-blue", bg_color: "#70B4E3" },
      { bg_color_class: "square-blue", bg_color: "#5264FF" },
      { bg_color_class: "square-red", bg_color: "#FF5A45" },
      { bg_color_class: "square-light-green", bg_color: "#afeaa5" },
      { bg_color_class: "square-turquoise", bg_color: "#53f3b7" },
      { bg_color_class: "square-lilac", bg_color: "#d686e4" },
      { bg_color_class: "square-fuchsia", bg_color: "#ca6d90" },
      { bg_color_class: "square-orange", bg_color: "#ffb270" },
    ],
    range: { startDate: null, endDate: null },
    hotspots: [],
    hotspot_id: "",
    // формируется из базы (результаты опроса)
    graphData: [
      { name: "Понравилась", value: 10 },
      { name: "Не понравилась", value: 10 },
    ],
    // количеыство ответов
    countAnswers: 0,
    dialogDrawer: false,
    graphLoad: false,
  }),
  props: {
    id: {
      type: Number,
      required: true,
    },
    // порядковый номер карточки на экране
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    item() {
      let item = this.$store.getters.getPoll(this.id);
      return item;
    },
    // для отображения периода опроса
    start() {
      return moment(this.item.start).format("DD.MM.YYYY");
    },
    end() {
      return moment(this.item.end).format("DD.MM.YYYY");
    },
    // для фильтрации статистики
    dateClass() {
      let endDate = new Date(this.item.end);
      let startDate = new Date(this.item.start);
      let now = new Date();
      if (endDate < now) {
        return "adv-date-end";
      } else if (endDate > now && now > startDate) {
        return "adv-date-now";
      } else {
        return "adv-date";
      }
    },
  },
  mounted() {
    this.getStats();
    this.getHotspots();
  },
  methods: {
    getHotspots: async function () {
      await requestApi
        .pollHotspotList({ poll_id: this.item.id })
        .then((res) => {
          this.hotspots = res;
        });
    },
    copyPoll() {
      let params = { poll: { ...this.item }, answers: this.item.polls };
      params.poll.name += " (копия)";
      this.$store.dispatch("copyPoll", params).then(() => {
        // открываем сообщение
        this.$store.dispatch("popupInfoOpen", {
          text: "Опрос успешно добавлен",
        });
      });
    },
    deletePoll() {
      this.$store.dispatch("deletePoll", { id: this.id }).then(() => {
        this.$store.dispatch("popupInfoOpen", {
          text: "Опрос успешно удален",
          timeout: 180000,
          action: {
            name: "Восстановить",
            method: "recoveryPoll",
            textThen: "Опрос успешно восстановлен",
            param: { id: this.id },
          },
        });
      });
    },
    getStats: async function () {
      this.graphLoad = false;
      await requestApi
        .pollGraphData({
          poll_id: this.item.id,
          hotspot_id: this.hotspot_id,
          range: this.range,
        })
        .then((data) => {
          let num = 0;
          this.countAnswers = 0;
          this.graphData = data.reduce((total, answers) => {
            total.push({
              name: answers.poll.title,
              value: parseInt(answers.cnt),
              bg_color_class: this.colors[num].bg_color_class,
              bg_color: this.colors[num].bg_color,
            });
            num++;
            this.countAnswers += parseInt(answers.cnt);
            return total;
          }, []);
          if (this.graphData.length === 0)
            this.graphData = [
              {
                name: "Нет заполненых ответов",
                value: 0,
                bg_color: "",
                bg_color_class: "",
              },
            ];
          this.graphLoad = true;
        });
    },
    openDialog() {
      this.dialogDrawer = true;
    },
    closeDialog() {
      this.dialogDrawer = false;
    },
    // обновляем дату и запрашиваем статистику
    changeDate(range) {
      this.range = range;
      this.getStats();
    },
  },
};
</script>
